'use strict';

import _ from 'lodash';

import './UserCard.less';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import UserCardsLang from './UserCardsLang';
import langToReactElements from 'ck-core-client/source/functions/langToReactElements';
import MessageModal from 'ck-core-client/source/ui/MessageModal.jsx';
import AddUserCard from './AddUserCard.jsx';
import Frame from 'ck-core-client/source/ui/Frame';
import ClickToCopy from 'ck-core-client/source/ui/ClickToCopy';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';

export default class UserCard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			adding: false
		};
	}

	render() {
		const buttonDefaults = {
			size: 'tiny',
			colour: 'yellow',
			disabled: true,
			componentClass: RoundButton
		};

		const buttons = {
			START_CODING: {
				text: UserCardsLang.ACTIONS.START_CODING,
				handleClick: this.props.handleLogin
			},
			COPY_LINK: {
				text: UserCardsLang.ACTIONS.COPY_LINK,
				componentClass: ClickToCopy,
				copyText: this.props.giftHref
			},
			INVITE: {
				text: UserCardsLang.ACTIONS.INVITE,
				handleClick: () =>
					this.setState({
						adding: true
					}),
				className: 'addChild'
			},
			GIFT_PDF: {
				text: UserCardsLang.ACTIONS.GIFT_PDF,
				handleClick: () => window.open(this.props.giftPdfHref)
			},
			UNLINK: {
				text: UserCardsLang.ACTIONS.UNLINK,
				handleClick: () => {
					const unlinkButton = (
						<RoundButton
							size="small"
							handleClick={async (...args) => {
								try {
									await this.props.handleUnlink(...args);
								} finally {
									this.setState({ unlinking: false });
								}
							}}
							text={buttons.UNLINK.text}
							colour={buttons.UNLINK.colour}
						/>
					);

					const modal = (
						<MessageModal
							message={langToReactElements(UserCardsLang.CONFIRM_UNLINK.MESSAGE)}
							title={UserCardsLang.CONFIRM_UNLINK.TITLE}
							buttons={[unlinkButton]}
						/>
					);

					this.props.handleAddModal(modal);
				},
				colour: 'red'
			}
		};

		let classes = classnames('UserCard');

		const makeButtons = choices => {
			_.merge(buttons, choices);

			return (
				<div>
					{_.map(buttons, (button, key) => {
						_.defaults(button, buttonDefaults);

						return <button.componentClass key={key} {...button} />;
					})}
				</div>
			);
		};

		const makeAvatar = () => {
			let avatar = 'default-avatar';

			if (CK.isCoolMath()) {
				avatar = 'default-coolmath-avatar';
			}

			return (
				<div className="avatar">
					<ReactCKImage name={avatar} extraClasses={['img-responsive']} />
				</div>
			);
		};

		if (this.props.linkPending) {
			return (
				<div className={classes}>
					{makeAvatar()}
					<h1>Invitation pending: {this.props.name}</h1>
					<p>You need to login as this user to accept the invitation.</p>
					{makeButtons({
						UNLINK: {
							disabled: false
						}
					})}
				</div>
			);
		} else if (this.props.userId) {
			const { immutable } = this.props;

			classes = classnames(classes, immutable && 'immutable');

			return (
				<div className={classes}>
					{makeAvatar()}
					<div className="username">{this.props.name || 'No username set in editor yet'}</div>
					{!immutable && this.props.lastOnline && (
						<p>Last Online: {CK.fn.humaniseDate(this.props.lastOnline)}</p>
					)}
					{makeButtons({
						START_CODING: {
							handleClick: immutable ? () => Frame.mod().navigate('/platform-select/') : undefined,
							disabled: false
						},
						UNLINK: {
							disabled: !!immutable
						}
					})}
				</div>
			);
		} else {
			if (this.state.adding) {
				return (
					<AddUserCard
						{...this.props}
						handleCancel={() => this.setState({ adding: false })}
						handleLink={async (...args) => {
							await this.props.handleLink(...args);

							this.setState({ adding: false });
						}}
					/>
				);
			} else {
				return (
					<div className={classes}>
						{makeAvatar()}
						<div className="username">Free slot</div>
						{makeButtons({
							START_CODING: {
								disabled: false,
								handleClick: () => Frame.mod().navigate(this.props.giftHref)
							},
							COPY_LINK: {
								disabled: false
							},
							INVITE: {
								disabled: false
							},
							GIFT_PDF: {
								disabled: false
							}
						})}
					</div>
				);
			}
		}
	}
}

UserCard.propTypes = {
	handleLogin: PropTypes.func.isRequired,
	handleLink: PropTypes.func.isRequired,
	handleUnlink: PropTypes.func.isRequired,
	handleAddModal: PropTypes.func.isRequired,
	name: PropTypes.string,
	lastOnline: PropTypes.instanceOf(Date),
	immutable: PropTypes.bool,
	giftCode: PropTypes.string,
	giftHref: PropTypes.string,
	giftPdfHref: PropTypes.string,
	linkPending: PropTypes.bool,
	userId: PropTypes.number
};
